import React from 'react'

import ImageWithText from '../../components/ImageWithText'
import screenshotUrl from './screenshot.png'

const ProfessionalNetworkScreen3: React.FC = () => (
  <ImageWithText
    imageUrl={screenshotUrl}
    text={
      <p>
        Dive into key data about your professional connections. Track
        relationship health, revenue generated, and your clients' experience.
      </p>
    }
  />
)

export default ProfessionalNetworkScreen3
